export enum ItemStatus {
  NEW = 'new',
  ADDED = 'added',
  REMOVED = 'removed',
  UNCHANGED = 'unchanged',
}

export const getAllItemsToDisplay = <T>(
  items: T[],
  getKey: (item: T) => string,
  previousItems?: T[] | null
) => {
  if (!items?.length && !previousItems?.length) return [];

  if (previousItems === undefined) {
    return items.map((item) => ({ item, status: ItemStatus.UNCHANGED }));
  }

  if (!previousItems?.length) {
    return items.map((item) => ({ item, status: ItemStatus.NEW }));
  }

  const currentKeys = new Set(items.map(getKey));
  const previousKeys = new Set(previousItems.map(getKey));
  const allKeys = new Set([...previousKeys, ...currentKeys]);

  return Array.from(allKeys).map((key) => {
    const currentItem = items.find((item) => getKey(item) === key);
    const previousItem = previousItems.find((item) => getKey(item) === key);

    return {
      item: currentItem ?? previousItem!,
      status: !previousItem
        ? ItemStatus.ADDED
        : !currentItem
          ? ItemStatus.REMOVED
          : ItemStatus.UNCHANGED,
    };
  });
};
